import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { searchCancel } from '../../actions/SearchFieldActions';
import Modal from '../../components/Modal';
import './SearchingModal.sass';

class SearchingModal extends Component {
  constructor(props) {
    super(props);
    this.handleCancelSearch = this.handleCancelSearch.bind(this);
    this.mapPropsToContent = this.mapPropsToContent.bind(this);
  }

  handleCancelSearch() {
    const { dispatch } = this.props;
    dispatch(searchCancel());
  }

  mapPropsToContent() {
    const {
      searching,
      error: { type, message },
      onRetry,
      children
    } = this.props;
    if (type) {
      return (
        <span>
          {message}
          <button
            className="retry-btn"
            onClick={onRetry}
          >
            Retry
          </button>
        </span>
      );
    } else if (searching) {
      return (
        <span>
          { children }
          <span className="fa fa-spinner rotating" />
          <button
            className="cancel-btn"
            onClick={this.handleCancelSearch}
          >
            Cancel
          </button>
        </span>
      );
    }
    return <span />;
  }

  render() {
    const { searching, error: { type } } = this.props;
    return (
      <Modal
        open={searching || (!!type && type === 'SEARCH_IMAGE_ERROR')}
        showCloseButton={false}
        width="400pt"
        height="75pt"
        className={`image-searching-modal ${type ? 'error' : ''}`}
      >
        {this.mapPropsToContent()}
      </Modal>
    );
  }
}

SearchingModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string
  }).isRequired,
  onRetry: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired
};

function mapStateToProps({ SearchField: { searching, error } }) {
  return { searching, error };
}

export default connect(mapStateToProps)(SearchingModal);



// WEBPACK FOOTER //
// ./src/containers/Main/SearchingModal.jsx